import React from 'react';
import { motion } from 'framer-motion';
import { FaCopy } from 'react-icons/fa';
import { getRuntimeBadgeClass } from '../utils/layerUtils';
import { rowVariants } from '../utils/constants';

/**
 * Individual layer row component with separate copy column
 * @param {Object} props - Component props
 * @param {Object} props.layer - Layer data object
 * @param {function} props.onCopy - Function to handle copy action
 * @returns {JSX.Element} Table row with layer information
 */
function LayerRow({ layer, onCopy }) {
  const handleCopy = () => {
    onCopy(layer.arn, `ARN copied successfully!`);
  };

  return (
    <motion.tr variants={rowVariants} layout>
      <td>
        <span className={getRuntimeBadgeClass(layer.runtime, layer.runtimeVersion)}>
          {layer.runtimeVersion}
        </span>
      </td>
      <td>
        <span className={`arch-badge arch-badge-${layer.architecture}`}>
          {layer.architecture}
        </span>
      </td>
      <td>{layer.extensionVersion}</td>
      <td>{layer.agentVersion}</td>
      <td className="arn-cell">
        <code className="arn-text">{layer.arn}</code>
      </td>
      <td className="copy-cell">
        <button className="copy-button" title="Copy ARN" onClick={handleCopy}>
          <FaCopy className="copy-icon" />
        </button>
      </td>
    </motion.tr>
  );
}

export default LayerRow;
